import React from 'react';
import styled from 'styled-components';
import InfiniteScroll from 'react-infinite-scroller';
import { FormattedMessage } from 'i18n';
import InfiniteThreeDots from 'components/spinners/InfiniteThreeDots';
import FiltersComponent from './components/filters/FiltersComponent';
import { mediaQueries } from 'styles/utils/mediaQueries';

const subHeaderMessage =
  'Here you will find unusually affordable travel options. Often, the hotels or airlines have given high discounts due to poor booking conditions for a shorter period. Under the heading of travel tips we have selected some of these as inspiration for you. Choose one of them, or look for yourself <strong> among our millions of normal travel suggestions </strong>. NOTE! When the hotels or airlines receive enough bookings during these periods, the discount disappears without warning. <strong> Good luck! </strong>';

function AdvertsComponent({ packages, hasMore, showLoader, scrollWrapRef, title, onLoadMore, isHolidayPirates }) {
  return (
    <Root>
      <Title>{title}</Title>
      <Subheader>
        {isHolidayPirates ? (
          <FormattedMessage
            id={'adverts.template.subheader.HPR'}
            description={subHeaderMessage}
            defaultMessage={subHeaderMessage}
          />
        ) : (
          <FormattedMessage
            id={'adverts.template.subheader.message'}
            description={subHeaderMessage}
            defaultMessage={subHeaderMessage}
          />
        )}
      </Subheader>
      <Background>
        <FiltersComponent />
        <ScrollWrap ref={(ref) => (scrollWrapRef.current = ref)} key={0}>
          <PackagesInfiniteScroll pageStart={0} loadMore={onLoadMore} hasMore={hasMore}>
            {packages}
          </PackagesInfiniteScroll>
          {showLoader && (
            <LoaderWrap>
              <InfiniteThreeDots />
            </LoaderWrap>
          )}
        </ScrollWrap>
        {packages.length === 0 && <NoAdvertsComponent />}
      </Background>
    </Root>
  );
}

export default AdvertsComponent;

// Styled components
const Root = styled.div`
  position: relative;
`;

const PackagesInfiniteScroll = styled(InfiniteScroll)`
  gap: 32px;
`;

const Title = styled.h1`
  width: 100%;
  margin-top: 130px;
  margin-bottom: 35px;
  font-size: 72px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.templates.header};
`;

const Subheader = styled.div`
  max-width: 760px;
  margin: 0 auto 60px;
  font-size: 1.6em;
  color: ${({ theme }) => theme.colors.text.default};
  text-align: center;

  ${mediaQueries.fromAndBelow.tablet`
    margin: 0 15px 32px;
    text-align: justify;
  `}
`;

const Background = styled.div`
  padding-top: 35px;
  background: ${({ theme }) => theme.colors.primary.light};
`;

const ScrollWrap = styled.div`
  padding: 32px;

  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    ${mediaQueries.fromAndBelow.desktop`
      justify-content: center;
    `}
  }
`;

const LoaderWrap = styled.div`
  margin-bottom: 70px;
`;

function NoAdvertsComponent() {
  return (
    <NoAdvertsMessage>
      <FormattedMessage
        id={'noAdverts.message'}
        description={'Ooops! Looks like there are no packages for the selected filters.'}
        defaultMessage={'Ooops! Looks like there are no packages for the selected filters.'}
      />
    </NoAdvertsMessage>
  );
}

const NoAdvertsMessage = styled.div`
  margin-bottom: 35px;
  font-size: 36px;
  font-weight: 500;
  text-align: center;
  color: ${({ theme }) => theme.colors.primary.dark};
`;
